/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-09-04 17:54:38
 * @FilePath: \community-backendf:\community-frontend\src\lang\en-GB\en-GB.js
 * @Description:
 */
import { CREDIT_CENTER, TEMPLATE, POC, GALLERY, INVITER, FRAMEPAGE, SEARCH, POST, thread, CommunityApp, User, AppDownload, LifeStudio, Home, Common, pageName, draft, medals, merchaindise, shootOnOppo, contentCenter, memberShip, meetup, chat } from './page';

// 原始的app语言文案json
import appLanguage from './language.js';

// app与web语言映射关系 有映射关系的用appLanguage，无映射关系的用webLanguage。暂时只能映射纯文字，无法映射动态传参
import relation from '../relation';

let language = {};

// 转换app语言文案 json格式
appLanguage.resources.string.forEach((item) => {
  language[item['-name']] = item['#text'];
});

const { VITE_COUNTRY, VITE_BRAND } = import.meta.env;

let webLanguage = {

  CHINADescription: '一加手机官方论坛。一加手机开箱体验、测评报告、玩机技巧、手游攻略。与你分享美图及摄影技巧,众多大神教你轻松刷机,并由丰富手机资源任由下载。百万加油大家庭,交流更随心,一加社区官方论坛',
  INDescription: 'Talk, share, and learn everything about the beautiful possibilities of technology together with other OPPO fans.',
  GLOBALDescription: 'OPPO Global Community is an ever-expanding Ecosphere designed to bring worldwide users together. You can experience the latest OPPO content, share your inspiration and nurture your exclusive community.',
  PARISDescription: 'Introducing our new OnePlus Community experience, with a completely revamped structure, built from the ground-up.',

  numberWithCount: '{n} count',
  numberWithCount_few: '{n} few',
  numberWithCount_other: '{n} other',
  // 公共
  thread: 'Threads',
  cancel: 'Cancel',
  discardEdit: 'Are you sure to discard your edit?',
  discard: 'Yes',
  page: 'page',
  author: 'Author',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  noContent: 'No content',
  noResult: 'No result',
  send: 'Send',
  justNow: 'Just now',
  ago: 'ago',
  min: 'min',
  today: 'Today',
  left: 'left',
  day: 'day | day | days',
  hour: 'hour | hour | hours',
  minute: 'minute | minute | minutes',
  loading: 'Loading...',
  finished: 'No More',
  error: 'Load Failed',
  vote: '{n} vote | {n} vote | {n} votes',
  pullRefresh: 'Pull down to refresh',
  releaseRefresh: 'Release refresh',
  noMore: 'No more',
  goBack: 'Go Back',
  tryAgain: '',
  sthWrong: '',
  small: 'Small',
  default: 'Default',
  medium: 'Medium',
  large: 'Large',
  productAmbassador: 'Product Ambassador',
  ohNo: 'Oh no!\nSomething went wrong.\nPlease try again.',
  inCorrectImageFormat: 'Image format not supported',
  errorNetwork: 'Network is not available!',
  requestError: 'Request Error,please try again later!',
  fileValidate: 'You can only upload {type}.',
  sizeValidate: "You can't upload video larger than {size}.",
  videoTypeValidate: 'You can only upload video in mp4 format.',
  latestActivity: 'Latest activity',
  latestCreated: 'Latest created',
  bottomCookie:
    'We use cookies and similar technologies to make this site work properly and to analyse traffic and optimise your browsing experience. By continuing to browse the site, you agree to the use of such cookies. ',
  readMore: 'Read More',
  oppoCopyRight: `Copyright © 2004-${new Date().getFullYear()} OPPO. All rights reserved.`,
  oneplusCopyRight: `© 2013 - ${new Date().getFullYear()} OnePlus. All Rights Reserved.`,
  quote: 'Quote',
  openAppONEPLUS: 'Open with the OnePlus Community App',
  openAppOPPO: 'Open with the OPPO Community App',
  openStore: 'Are you sure to open Google Play Store?',
  yes: 'Yes',
  followEach: 'followEach',
  support: 'Support',
  oppoOfficialWebsite: 'Official Site',
  oneplusOfficialWebsite: 'Official Site',
  oneplusOnlineStore: 'Store',

  // 首页
  home: 'Home',
  myCircles: 'My Circles',
  allCircles: 'All Circles',
  store: 'Store',
  newThread: 'New Thread',
  oneplus: 'OnePlus Community',
  explore: 'Explore',
  hotTopics: 'Hot Topics',
  topCreators: 'Top Creators',
  activeRanking: 'Active Ranking',
  recommended: 'Recommended',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  logIn: 'Log In',
  login: 'Log in',
  myDraft: 'My Drafts',
  noMoreThread: 'No more content',
  notJoinThisCircle: "You haven't join this circle yet.",
  myFollowing: 'My Following',
  posts: 'Posts',
  homeTitle: `${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : `OPPO${VITE_COUNTRY === 'GLOBAL' ? ' Global' : ' India'}`} Community`,
  noFollow: "You haven't followed anyone yet.",
  noFollowContent: 'No content',
  joinNewCircles: 'Join new circles',
  mark: 'Mark',
  marked: 'Marked',
  unMark: 'Unmark',
  askAssist:'Ask & Assist',
  none: 'none',
  dayCount: '{n} day | {n} day | {n} days',
  reload: 'Reload',
  loginFail: 'Login error, please try again',
  logoutFail: 'Logout error, please try again',
  success: 'Success',
  fail: 'Fail',

   // 首页签到
   newAbilityNotice:'You can now check in via mobile web!',
   memberCenter: 'Member Center',
   moreTask: 'More Tasks',
   creationHall: 'Creation Hub',
   dayStreak: 'Day Streak | Days Streak',
   totalCheckIn: 'Total Check-In',
   growthValue: 'Growth Point | Growth Points',
   signinPoints: 'RedCoin | RedCoins',
   signDays: '{n} day | {n} days',
   //额外奖励的提示语
   signinTips: 'Check in for {n} more consecutive day to earn | Check in for {n} more consecutive days to earn',
   extGrowthValue:'{n} extra Growth Point | {n} extra Growth Points',
   atAnd:' and ',
   extCredit:'{n} extra RedCoin | {n} extra RedCoins',

  // 圈子
  updates: '{n} update | {n} update | {n} updates',
  join: 'Join',
  pending: 'Pending',
  ownBy: 'Owned by',
  members: 'Member | Member | Members',
  requests: 'Requests',
  decline: 'Decline',
  accept: 'Accept',
  confirmQuitCircle: 'Do you want to quit Circle？',
  confirmQuit: 'Yes',
  quitCircle: 'Quit Circle',
  quit: 'Quit',
  owner: 'Owner',
  circleOwner: 'Circle Owner',
  circleAssistant: 'Circle Assistant',
  circleAdministrators: 'Circle administrators',
  circleMember: 'Circle members',
  circleName: 'Circle Name',
  circleNamePlaceholder: 'Please enter the circle name',
  circleIntroduction: 'Circle introduction',
  circleIntroductionPlaceholder: 'Please enter the circle introduction',
  createReason: 'Reason for application',
  createReasonPlaceholder: 'Tell us why you want to create this circle',
  circlePermissionType: 'Types of circle permission',
  everyoneCanJoin: "Members don't need permission to join",
  notEveryoneCanJoin: 'Members need permission to join',
  addCover: 'Add cover',
  notJoinCircle: "You haven't joined any circle yet.",
  createCircle: 'Create a circle',
  createCircleTitle: 'Create circle',
  circleNameHasBeenUsed: 'This circle name has been taken.',
  needSelectCircleAttribute: 'Please select the circle attribute',
  circleManageTitle: 'Circle management',
  editCircle: 'Edit Circle',
  checkMyCircle: 'Please log in to check the circles you have joined.',
  submitApplication: 'Submit application',
  remove: 'Remove',
  setAssistant: 'Set as assistant',
  setAssistantTitle: 'Set circle assistant',
  setAssistantContent: 'Are you sure to set as assistant?',
  cancelAssistantTitle: 'Cancel assistant',
  cancelAssistantContent: 'Are you sure to cancel assistant?',
  confirmAssistant: 'Yes',
  removeAssistant: 'Cancel circle assistant',
  requestSend: 'Send',
  removeMember: 'Remove Member',
  removeMemberTitle: 'Do you want to remove member',
  submitted: 'Submitted',
  submittedContent: 'Your application is now under review by the circle owner',
  submittedTeamContent: 'Your aplication is now under review by the community team',
  ciecleEditReview: 'Your edit is now under review',
  needJoinCircle: 'Please join the circle first.',
  manageUser: 'Manage User',
  circleRequest: 'Circle request',
  threads: 'threads',
  threadsFromCircle: 'thread | thread | threads',
  engagement: 'engagement | engagement | engagements',
  viewAll: 'View All',
  all: 'All',
  recent: 'Recent',
  allCircleTitle: `All Circles - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  myCircleTitle: `My Circles - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  circleDetailTitle: `{circleName} - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  joined: 'Joined',
  joinSuccess: 'You have joined the circle',
  quiteInAllCircle: 'Are you sure to leave this circle?',
  copyToast: 'Link copied successfully',

  // 帖子详情
  moment: 'Moment',
  article: 'Article',
  poll: 'Poll',
  prizeDraw: 'Prize Draw',
  application: 'Application',
  ended: 'Ended',
  feedBack: 'Feedback',
  rate: 'Rate',
  webRate: 'Rate the Community',
  lastEdit: 'Last edit:',
  message: 'Message',
  like: 'Like | Like | Likes',
  unlike: 'Unlike',
  share: 'Share',
  orCopyLink: 'OR COPY LINK',
  allComments: 'All comments',
  mostLike: 'Most liked',
  latest: 'Latest',
  earliest: 'Earliest',
  reply: 'Reply',
  pollShut: 'Poll closed',
  pollTag: 'POLL',
  addComment: 'Add a comment...',
  report: 'Report',
  edit: 'Edit',
  delete: 'Delete',
  copyLink: 'Copy Link',
  hideComment:'Hide comments',
  stick: 'Stick',
  cancelStick: 'Cancel Stick',
  copySuccess: 'Link copied!',
  closeComment: 'This thread is not open for further comments and replies.',
  closeCommentSimple: 'This thread is not open for further comments.',
  submit: 'Submit',
  reportPlacement: 'Please tell us why you want to report',
  comment: 'comment',
  replyTo: 'Reply to ',
  wordLimit: 'You only can input no more than {wordLimit} words',
  imgUploading: 'Image uploading',
  mute: 'You have been muted due to violating community Terms & Rules.',
  deleteCommentReply: 'You are not allowed to reply under a deleted comment.',
  commentDeleted: 'This comment has been deleted!',
  viewAllReplies: 'View all {n} replies',
  confirmVoteTitle: 'Are you sure to vote?',
  voteConfirm: 'Yes',
  noMoreComment: 'No more comment',
  noMoreReply: 'No more reply',
  copy: 'Copy',
  copyText:'Copy',
  replyCopySuccess: '{type} has been copied',
  profile: 'Profile',
  mightBeLike: 'You may also like',
  sureDelete: 'Are you sure to delete this content',
  quote: 'Quote',
  reportSuccess: 'Report Success',
  commentMark: 'Mark | Mark | Marks',
  commentUnMark: 'Unmark',
  mostMark: 'Most marked',
  close: 'Close',
  unClose: 'Open',
  closeThisThread: 'Close this thread?',
  closeConfirm: 'This thread will no longer be open for further comments and replies.',
  threadClose: 'Closed',
  unClosed: 'Opened',
  move: 'Move',
  moveThreadTo: 'Move this thread to "{type}"?',
  threadMoved: 'Thread moved',
  exclude: 'Exclude',
  unExclude: 'Include',
  excludeThisThread: 'Exclude this thread?',
  excludeConfirm: 'The visibility of this thread will be decreased.',
  excluded: 'Excluded',
  unExcluded: 'Included',
  reason: 'Reason',
  deleted: 'Deleted',
  closed: 'Close',
  addLabel: 'Add Label',
  mediaLabel: 'Media Label',
  confirm: 'Confirm',
  addRemark: 'Add remarks here',
  next: 'Next',
  selectMedia: 'Selected {n} media',
  highlights: 'Best Pick',
  remark: 'Remark',
  markBestTitle: 'Mark as Best Pick',
  markBestContent: 'The thread will be more visible on the Homepage and have a label on the title.',
  markSave: 'Mark',
  markBestCancelTitle: 'Remove from Best Pick',
  markBestCancelContent: 'There will be no the "Best Pick" label marked in the thread.',
  markCancel: 'Remove',
  succeed: 'Succeed',
  unHighlights: 'Remove Best Pick',
  seletedOnce: "You can't multi-select content that has already been added label",
  someNotSelected: 'Some cannot be selected',
  selectedLabel: 'Selected label',
  addedLabel: 'Label added',
  selected: 'Selected',
  selectedAll: 'All',
  labelNotSaved: 'label not saved',

  mergeBtn:'Merge',
  cancleMergeBtn:'Cancle Merge',
  threadMergedText:'This thread has been merged into the main discussion. Please continue the conversation in the main thread:',
  goToThread:'Take me to thread',
  mergeDialogTitle:'Merge thread',
  mergeDialogContent:'Note: If this thread is merged, its content will be converted into a comment under the main thread.',
  mergeDialogPlaceholder:'Enter the destination thread ID',
  mergeDialogBtn:'Confirm Merge',
  mergedDiscussion:'Merged Discussion',
  mergeText:'This content was merged into an existing thread. Similar posts are merged as comments under the main thread to keep discussions organized.',
  mergeSuccess:'Merge Successful',
  mergeFail:'Merge Failed',
  mergeIdFail:'The selected main thread is incorrect. Please choose a valid thread.',

  // 官方回复
  verified:'Verified',
  cancleVerified:'Remove Verified',
  verifiedTag:'Answered',
  verifiedTooltip:'Reply from the Community Team or a Moderator.',

  // 精选
  featured:'Featured',
  cancleFeatured:'Remove Featured',
  featuredTooltip:'Chosen by the Community Team or Moderators for its quality.',

  // 发帖
  upload: 'Uploading media file...',
  chooseCircle: 'Choose a circle you have joined',
  editorPlaceholder: 'Share your story…',
  title: 'title',
  uploadVideo: 'Upload Video',
  addYoutube: 'Embed Youtube Video',
  youtubePlaceholder: 'Input YouTube video link',
  youtubeUrl: 'Youtube URL',
  ok: 'OK',
  option: 'Option',
  addOption: 'Add option',
  closeTips: 'Close this poll after',
  resetCloseTime: 'Reset closing time',
  notReset: 'Do not reset',
  post: 'Post',
  linkValidate: 'The link you inserted is invalid. Please insert a link starting with http or https',
  linkTips: 'Please add a link starting with http:// or https://',
  linkLableTips: 'Text (optional)',
  incorrectFormat: 'Incorrect format',
  selectCircle: 'Please select a circle',
  titleValidate: 'Please complete title',
  contentValidate: 'Write something before you post',
  pictureLimit: 'You can upload no more than {limit} pictures',
  uploading: '{type} uploading',
  video: 'Video',
  image: 'Image',
  chooseACircle: 'Choose a circle',
  pollContentValidate: 'Text must be entered for the poll thread option',
  pollNumValidate: 'The poll thread can have at least two options',
  selectDay: 'Please select closed day',
  default: 'Default',
  medium: 'Medium',
  large: 'Large',
  superLink: 'super link',
  atSomeBd: 'mention someone',
  emoji:'emoji',
  uploadImage: 'upload image',
  draftSaved: 'Draft saved',
  draftSaving: 'Draft saving...',
  saveEdit: 'Save as draft?',
  saveDraft: 'Yes',
  discardDraft: 'Discard',
  publishTitle: `New thread - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  addFlair: 'Add tag',
  resumeDraft: 'The draft was closed by accident. Do you want to recover the previous draft? ',
  resume: 'Recover',
  preview: 'Preview',
  myprofileTips: 'Posting under "My profile" will limit the visibility of your thread',
  recommendCircleTips: "Here're more circles that might fit your content",
  onlyOneMediaType: "Image and video can't upload at the same time.",
  onlyOneVideo: 'You can upload no more than 1 video',
  videoLimit: 'You can upload no more than 1 video',
  uploadTips: 'Upload photo and video here!',
  needContent: 'Write something before you post',
  autoSave: 'Will automatically save',
  select: 'Select',
  uploadFailed: 'Upload failed. Unable to post your thread.',
  uploadFailedPreview: 'Upload failed. Unable to preview your thread.',
  uploadError: 'Upload failed.',
  topicTips: 'Adding topics is available here',
  backToEdit: 'Back to edit',

  // 搜索
  trends: 'Trends',
  history: 'History',
  clearHistory: 'Clear',
  circle: 'Circle',
  user: 'User',
  confirmClearHistory: 'Are you sure to clear all the history?',
  confirmClear: 'Yes',
  search: 'Search',
  searchUserName: 'Enter user name',
  searchUserNameValidate: 'Please enter user name',
  addLink: 'Add link',
  text: 'Text',
  link: 'Link',
  searchInside: 'Search inside {circleName}',
  searchCircle: 'Search inside this circle',
  mostRelevant: 'Most relevant',
  mostViewed: 'Most viewed',
  mostCommented: 'Most commented',
  allTime: 'All time',
  pastWeek: 'Past week',
  pastMonth: 'Past month',
  pastYear: 'Past year',
  tagPeople: 'Tag People',

  searchMyCircle:'Search My Articles',
  searchOthers:`Search Others' Articles`,
  searchThisCircle:'Search This Circle',
  searchAll:'Search All',

  //个人详情
  name: 'Name',
  userThread: `Thread | Thread | Threads`,
  userThreads: 'Threads',
  unreleasedPost: 'Unreleased post',
  userLikes: 'Likes',
  likeReceived: 'Likes received',
  save: 'Save',
  nameChangeLimit: '*You can only change your Username for one time',
  alreadChangeName: 'You have already changed your username before',
  userNameValidate: 'Please enter the username',
  editUserName: 'Edit username',
  aboutUs: 'About us',
  confirmLogOut: 'Are you sure to log out?',
  bio: 'Bio',
  editBio: 'Edit bio',
  editAvatar: 'Edit avatar',
  setting: 'Settings',
  lastActivities: 'Last activity',
  userlTitle: `{userName} - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  profileLinkCopied: 'Profile link copied',
  userNameRepeat: 'This username has been taken.',
  delDraft: 'Delete this draft?',
  noTitle: 'No title temporarily',
  block: 'Block',
  unblock: 'Unblock',
  blockTips: "They won't be able to comment, reply, follow, message you or view your profile. They won't be notified that you blocked them. ",
  privacy: 'Privacy',
  blockList: 'Block list',
  blockContentTips: "You've blocked this user",
  blockedContentTips: "You're not allowed to view the profile page of this user. ",
  reviewing: 'Under Review',
  notApproved: 'Removed',
  myposts: 'Posts',
  language: 'Language',
  done: 'Done',
  displayDeviceSource: 'Display device source',
  deviceSourceVisable: 'Device source visable. You can see it in the post or comment',
  deviceSourceHidden: 'Device source hidden. You can’t see it in the post or comment',
  muteUser: 'Mute',
  unMuteUser: 'Unmute',
  unMuteThisUser: 'Unmute this user?',
  unMuteSuccess: 'Unmuted',
  duration: 'Duration',
  permanent: 'Permanent',
  muteSuccess: 'Muted',
  muteMaxDate: '90 days maximum',
  stickyProfile: 'Sticky on profile',
  unStickyProfile: 'Unsticky on profile',
  stickied: 'Stickied',
  unStickied: 'Unstickied',
  myProfile: 'My profile',
  celebrateJoin:
    'Incredible, your continuous journey with the OPPO Community started {n} day ago. | Incredible, your continuous journey with the OPPO Community started {n} day ago. | Incredible, your continuous journey with the OPPO Community started {n} days ago.',
  medal: 'Medal',

  // 话题
  topic: 'Topic',
  hotTopicList: 'Hot Topics',
  latestTopic: 'Find the trending topics and join in on the conversation.',
  unJoinTopic: 'Are you sure to unjoin this topic?',
  topicMax: "You can't add more than three topics.",
  more: 'More',
  hotTopic: 'Hot Topics',
  views: 'view | view | views',
  myCollect: 'My Following',
  joinTopic: 'Post',
  addTopicTitle: 'Add a topic',
  searchTopic: 'Search a topic',
  allTopic: 'All topics',
  allTopics: 'All topics',
  addTopics: 'Add topics',
  followSuccess: 'Follow Success',

  // 关注
  following: 'Following',
  follower: 'Follower | Follower | Followers',
  follow: 'Follow',
  unFollow: 'Unfollow',

  // 系统
  likes: 'Like',
  notification: 'Notifications',
  activities: 'Activities',
  followers: 'Followers',
  messages: 'Messages',
  checkSystem: 'Please log in to check the notifications',
  contentDelete: 'This content has been deleted.',
  contentReview: 'This content is under review.',
  contentReject: 'This content has not been approved.',
  threadDelete: 'This thread has been deleted.',
  social: 'Social',
  noTextContent: 'No text content',
  commentAreplies: 'Comments & replies',
  socialTitle: `Social - ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  deleteChat: 'Are you sure to delete all the conversation history with this user?',
  deleteMsg: 'Are you sure to delete this message?',
  topicDelete: 'This topic has been deleted.',
  systemWapPic: 'Picture comment',
  loginTips: 'Please log in to continue',
  sendMessage: 'Message...',

  //协议相关
  privacyPolicy: 'Privacy Policy',
  termsConditions: 'Terms & Conditions',
  userAgreement: 'User Agreement',
  useOfCookies: 'Use Of Cookies',
  cookiesStatement: 'Cookies Statement',
  privacyNotice: 'Privacy Notice',
  termsOfUse: 'Terms of Use',
  copylink: 'Copy Link',
  facebook: 'Facebook',
  twitter: 'Twitter',

  // 表单
  communityName: 'Your community username',
  currentName: "Recipient's full name",
  currentMobile: "Recipient's mobile phone",
  address: "Recipient's address",
  pleaseEnter: 'Please enter',
  lengthLimit: 'You need to write no less than {limit} characters',
  lengthLimitPlaceholoder: 'For Indian users, please include your PAN number here',
  contestDone:
    "We've received your shipping information and will send your prize(s) within 40 working days. You will receive a DHL email when the prize(s) are released. Thank you for your support. We look forward to your unboxing of the prize.",
  contestFinish:
    "You've missed the deadline to submit your shipping information and redeem your prize(s) successfully. We hope to see you in future contests.",
  contestNoResult: 'Unfortunately, you did not win the prize(s)~Looking forward to participating next time',
  contestEditInfo: 'Modify shipping information',
  contestTitle: `Many congratulations on winning one of the ${
    VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : `OPPO${VITE_COUNTRY === 'MY' ? ' Global' : ''}`
  } Community prizes`,
  contestContent:
    'Please fill in the form by {time}, and double-check the validity of the shipping information, especially if the detailed address matches your Identity Card info, or if the postcode matches a specific area in your city or country. You understand and agree that you waive the right to claim the prizes due to the wrong, mismatching, or incomplete shipping information.',
  goHome: 'Return to the community homepage',
  retry: 'Retry',

  // 编辑器
  justifyleft: 'Align left',
  justifycenter: 'Align center',
  justifyright: 'Align right',
  InsertUnorderedList: 'Bullet list',
  InsertOrderedList: 'Numbered list',

  syncLabel2Thread : 'Sync labels to thread or comment',

  // emoji
  emojiLimitToast:'Only up to {number} special emoticons can be inserted.',
  emojiSticker:'[Sticker]',

  // live
  liveName:'Live',

  livestreamTitle:'OnePlus Community Homepage',

  oppoLivestreamTitle:'OPPO Community Homepage',

  template: {
    ...TEMPLATE
  },

  creditCenter: {
    ...CREDIT_CENTER
  },
  poc: {
    ...POC
  },
  // 作品页
  gallery:{
    ...GALLERY
  },
  // 邀请制
  inviter:{
    ...INVITER
  },
  searchModule:{
    ...SEARCH
  },
  postModule:{
    ...POST
  },
  framepage: {
    ...FRAMEPAGE
  },
  threadPage: {
    ...thread
  },
  communityApp: {
    ...CommunityApp
  },
  userProfile: {
    ...User
  },
  appDownload: {
    ...AppDownload
  },
  lifeStudio: {
    ...LifeStudio
  },
  homePage: {
    ...Home
  },
  common: {
    ...Common
  },
  pageName: {
    ...pageName
  },
  draft: {
    ...draft
  },
  medals:{
    ...medals
  },
  merchaindise: {
    ...merchaindise
  },
  shootOnOppo: {
    ...shootOnOppo
  },
  contentCenter: {
    ...contentCenter
  },
  memberShip: {
    ...memberShip
  },
  meetup,
  chat
};

String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2);
};

for (let i in relation) {
  if (webLanguage[i] && language[relation[i]]) {
    webLanguage[i] = language[relation[i]];
  }
}

// 暂无多语言翻译的文案
webLanguage = {
  ...webLanguage
};

// 动态文案
webLanguage = {
  ...webLanguage,
  follower: 'Follower | Follower | Followers'
};

export default {
  ...webLanguage
};
